import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import './MapScreen.scss'

import { Headerbar, Loader, ListContainer, ConfirmButton } from '../../Reusable'

import { Fire, Time, Tools } from '../../../services'
import { CopyToClipboard } from 'react-copy-to-clipboard'

import FadeIn from 'react-fade-in';
import GoogleMapReact from 'google-map-react';
import ProMarker from './ProMarker' 

const { useHistory } = require('react-router-dom')

interface Props {
  match: any;
}
const MapScreen: React.FC<Props> = (props) => {
  
  const user = useSelector(state => state.authReducer.user)
  const history = useHistory()
  const [pros, setPros] = React.useState<any[]>([])
  const [stats, setStats] = React.useState<any>({})

  React.useEffect(() => {
    fetchSchools()
    fetchStats()
  }, [])


  const fetchSchools = async () => {
    try {
      const pros = await Fire.list(Fire.store().collection('pros'))
      setPros(pros.filter((item) => item.lat !== undefined))
    } catch (err) {
      console.warn(err)
    }
  }
  const fetchStats = async () => {
    try {
      const genericRef = Fire.store().collection('stats').doc('generic')
      const generic = await Fire.doc(genericRef)
      if (generic) {
        setStats(generic || {})
      }
    } catch (err) {
      console.warn(err)
    }
  }

  return (
    <div className="wrapper">
      <Headerbar
        title="Map"
        />

      <div className="content-wrapper">
        <div className="content users">
          <div className="container-fluid">
            
            <FadeIn>

            <div className="row">
              <div className="info-box col-sm">
                <span className="info-box-icon bg-success"><i className="far fa-flag"></i></span>

                <div className="info-box-content">
                  <span className="info-box-text">Professionels</span>
                  <span className="info-box-number">{stats.pros_count || 0}</span>
                </div>
              </div>

            </div>

            <div className="card">
              <div className="card-header">
                <h3 className="card-title">Tous nos professionnels</h3>
              </div>
              <div className="card-body">
                <div style={{ height: '60vh', width: '100%' }}>
                  <GoogleMapReact
                    bootstrapURLKeys={{ key: 'AIzaSyBR046smIiQUeRbBaErZWkgtdiMFmOlAlc' }}
                    defaultCenter={{
                      lat: 48.866290,
                      lng: 2.343610,
                    }}
                    defaultZoom={11}
                  >
                    {pros.map((item, index) => (
                      <ProMarker
                        key={index}
                        lat={item.lat}
                        lng={item.lng}
                        pro={item}
                        onPress={() => history.push('/admin/pro/' + item.id + '/recap')}
                      />
                    ))}
                  </GoogleMapReact>
                </div>
              </div>
            </div>

            </FadeIn>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MapScreen
